import { render } from "./ScSimpleDraggable.vue?vue&type=template&id=504ff6b6&scoped=true"
import script from "./ScSimpleDraggable.vue?vue&type=script&lang=js"
export * from "./ScSimpleDraggable.vue?vue&type=script&lang=js"

import "./ScSimpleDraggable.vue?vue&type=style&index=0&id=504ff6b6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-504ff6b6"]])

export default __exports__